import API from './commons/Api.js';
import router from './commons/Router.js';
import { eventBus, EVENTS } from './commons/EventBus.js';
import Utils from './commons/utils.js';
import { Paginator } from "./commons/paginator.js";
let downloadTimer = false;
let onPartecipa = () => { };
eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
    const template = data.template;

    if (template != 'login') {
        return;
    }

    /* caffeina track */
    if(location.pathname.split("/")[2] == "verify" && location.pathname.split("/")[1] == "app"){
      Utils.alertMessage("Complimenti, hai verificato il tuo account. Ora puoi effettuare la login.");
      eventBus.emit(EVENTS.REGISTRAZIONE_CONFERMATA);
      window.history.pushState({page: location.href}, "", "/login");
    }

  if(location.pathname.split("/")[2] == "verifyMinor" && location.pathname.split("/")[1] == "app"){
    /*let formData=new FormData();
    let token="";
    for(let i=3;i<location.pathname.split("/").length;i++)
        token+=location.pathname.split("/")[i]+"/";
    formData.append("token",token.slice(0, -1));
    API.postFormData("community/setMinoreVerificato", formData, function (resp) {
      Utils.hideWaitingLoader();
      Utils.alertError(resp);
      if (resp.status == 1) {
        localStorage.removeItem("rds_user");
        Utils.alertMessageGiochi("Verifica avvenuta con successo!");
        replaceNavigation(window.slug_game);
      } else {
        Utils.alertError("Errore la verifica1");
      }
    }, function () {
      Utils.hideWaitingLoader();
      Utils.alertError("Errore la verifica2");
    }, 300000);*/
    Utils.alertMessage("Complimenti, hai verificato il tuo account. Ora puoi effettuare la login.");
    eventBus.emit(EVENTS.REGISTRAZIONE_CONFERMATA);
    window.history.pushState({page: location.href}, "", "/login");

  }


  if(location.pathname.includes('changeMail')) {
    if(typeof data.parameters.f !== 'undefined' && data.parameters.f==1){
      Utils.alertMessage("Completa il cambio indirizzo email cliccando sul link che ti abbiamo inviato al nuovo indirizzo email");
    }
    else {
      localStorage.removeItem("rds_user");
      Utils.alertMessage("Processo di cambio email completato correttamente!");
    }
    window.history.pushState({page: location.href}, "", "/profilo");
  }


});

